import React from "react";

import { MenuItem } from "@mui/material";
import { DefaultDateOptionsColumn, DefaultPeriodOptionsColumn } from "Constants";
import { format, utcToZonedTime } from "date-fns-tz";

import {
  DateSelectorDescription,
  DateSelectorItemContainer,
  DateSelectorLabel,
  PeriodSelector,
} from "./styles";

export interface PeriodOptions {
  name: string;
  column: DefaultPeriodOptionsColumn;
  type: DefaultDateOptionsColumn;
  totalDays?: number;
  description?: string;
  icon?: JSX.Element;
}

interface DateSelectorFilterProps {
  options: PeriodOptions[];
  value: DefaultPeriodOptionsColumn;
  onChange: (value: DefaultPeriodOptionsColumn) => void;
}

export const DateSelectorFilter = ({ options, onChange, value }: DateSelectorFilterProps) => {
  const formatDate = (date: Date) => {
    if (date) {
      return format(
        utcToZonedTime(date, Intl.DateTimeFormat().resolvedOptions().timeZone),
        "dd MMM yyyy"
      );
    }
  };

  const getDescriptionText = (value: number) => {
    const today = new Date();
    const startDate = new Date(Date.now() - value * 24 * 60 * 60 * 1000);

    return `${formatDate(startDate)} - ${formatDate(today)}`;
  };

  return (
    <PeriodSelector
      name="room"
      value={value}
      onChange={(event) => {
        onChange(event.target.value as DefaultPeriodOptionsColumn);
      }}
      data-cy={`room`}
      displayEmpty
      renderValue={(value) => {
        const currentOption = options.find((option) => option.column === value);

        return `${currentOption?.name}`;
      }}
      style={{ width: "188px" }}
    >
      {options?.map((option, index: number) => (
        <MenuItem
          key={option.name || index}
          value={option.column}
          data-cy={`period-option-${option.name}`}
        >
          <DateSelectorItemContainer>
            <DateSelectorLabel>{option.name}</DateSelectorLabel>
            {option.totalDays ? (
              <DateSelectorDescription>
                {getDescriptionText(option.totalDays)}
              </DateSelectorDescription>
            ) : null}
            {option.description ? (
              <DateSelectorDescription>{option.description}</DateSelectorDescription>
            ) : null}
            {option.icon ? option.icon : null}
          </DateSelectorItemContainer>
        </MenuItem>
      ))}
    </PeriodSelector>
  );
};
